import React, { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { getLocalStorageItem } from '../../../services/localStorageUtils';
import ROLES from '../../../constants/roles';
import {
  expiryTimeCalculation,
  calculateTotalSeconds,
} from '../../pages/authentication/two-factor-auth/couter';

export const ProtectedRouteForLoggedInUser = () => {
  const roleCheck = getLocalStorageItem('role');
  const otpFromLocal = getLocalStorageItem('otp');

  const formattedDifference = expiryTimeCalculation();
  const secondsStr = calculateTotalSeconds(formattedDifference);
  const [otp, setOtp] = useState(otpFromLocal);

  useEffect(() => {
    const timer = setTimeout(() => {
      localStorage.removeItem('otp');
      setOtp(null);
    }, secondsStr);
    return () => clearTimeout(timer);
  }, [otp]);

  const getNavigationPath = (role, isOtp) => {
    if (role === ROLES.SUPER_ADMIN || role === ROLES.SUPER_MANAGER) {
      return <Navigate to="/dashboard" />;
    }
    if (role === ROLES.SALES_ADMIN) {
      return <Navigate to="/sales-admin-dashboard" />;
    }
    if (role === ROLES.SALES) {
      return <Navigate to="/sales-dashboard" />;
    }
    if (role === ROLES.ADMIN) {
      return <Navigate to="/admin-dashboard" />;
    }
    if (role === ROLES.MANAGER || role === ROLES.MEMBER) {
      return <Navigate to="/invoices" />;
    }
    if (isOtp) {
      return <Navigate to="/otp-auth" />;
    }
    return <Outlet />;
  };

  return getNavigationPath(roleCheck, otp);
};

export const ProtectedRouteForAllRole = () => {
  const roleCheck = getLocalStorageItem('role');

  return roleCheck === ROLES.SUPER_ADMIN ||
    roleCheck === ROLES.MANAGER ||
    roleCheck === ROLES.MEMBER ||
    roleCheck === ROLES.SUPER_MANAGER ||
    roleCheck === ROLES.SALES_ADMIN ||
    roleCheck === ROLES.SALES ||
    roleCheck === ROLES.SUPPORT ||
    roleCheck === ROLES.ADMIN ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};

export const ConfigurePageAfterAppRun = () => {
  const roleCheck = getLocalStorageItem('role');

  if (roleCheck === ROLES.ADMIN) {
    return <Navigate to="/admin-dashboard" />;
  }
  if (roleCheck === ROLES.MANAGER || roleCheck === ROLES.MEMBER) {
    return <Navigate to="/invoices" />;
  }
};

export const ProtectedRouteForSA = () => {
  const roleSuperAdmin = getLocalStorageItem('role');
  return roleSuperAdmin === ROLES.SUPER_ADMIN ||
    roleSuperAdmin === ROLES.SUPER_MANAGER ||
    roleSuperAdmin === ROLES.SALES_ADMIN ||
    roleSuperAdmin === ROLES.SALES ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};

export const ProtectedRouteForAdmin = () => {
  const roleAdmin = getLocalStorageItem('role');

  return roleAdmin ? <Outlet /> : <Navigate to="/login" />;
};

export const ProtectedRouteForSalesAdmin = () => {
  const roleAdmin = getLocalStorageItem('role');

  return roleAdmin ? <Outlet /> : <Navigate to="/login" />;
};

export const ProtectedRouteForAdminAndUser = () => {
  const roleCheck = getLocalStorageItem('role');

  return roleCheck === ROLES.MANAGER ||
    roleCheck === ROLES.MEMBER ||
    roleCheck === ROLES.ADMIN ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};

export const ProtectedRouteForRootAdmin = () => {
  const roleRootAdmin = getLocalStorageItem('role');

  return roleRootAdmin === ROLES.ADMIN ? <Outlet /> : <Navigate to="/login" />;
};

export const ProtectedRouteForUser = () => {
  const roleUser = getLocalStorageItem('role');

  return roleUser === ROLES.MEMBER ? <Outlet /> : <Navigate to="/login" />;
};

export const ProtectedRouteForOtp = () => {
  const otp = getLocalStorageItem('otp');
  return otp ? <Outlet /> : <Navigate to="/login" />;
};
